import { combineReducers } from 'redux';
import { uniqBy } from 'lodash/fp';

import * as types from './constants';

const initialState = [];
const items = (state = initialState, { type, payload }) => {
  switch (type) {
    case types.CLEAR_ITEMS:
      return [];

    case types.FETCH_ITEMS:
      return uniqBy('id', [...state, ...payload]);

    case types.FETCH_ITEM:
    case types.UPDATE_ITEM:
    case types.ADD_ITEM:
      return state.filter(item => item.id !== payload.id).concat([payload]);

    case types.DELETE_ITEM:
      return state.filter(item => item.id !== payload);

    case types.UPDATE_INVENTORY:
      return state.map((item) => {
        if (item.assignmentId !== payload.productId) {
          return item;
        }

        return { ...item, inventory: payload.newInventory };
      });

    case types.BULK_UPDATE_INVENTORY:
      return state.map((item) => {
        const productUpdate = payload.find(update => update.productId === item.assignmentId);
        if (!productUpdate) {
          return item;
        }

        return { ...item, inventory: productUpdate.newInventory };
      });

    default:
      return state;
  }
};

const reducer = combineReducers({
  items,
});
export default reducer;
